import { render, staticRenderFns } from "./AskDialog.vue?vue&type=template&id=5e438358&scoped=true"
import script from "./AskDialog.vue?vue&type=script&lang=js"
export * from "./AskDialog.vue?vue&type=script&lang=js"
import style0 from "./AskDialog.vue?vue&type=style&index=0&id=5e438358&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e438358",
  null
  
)

export default component.exports